<div
  fxLayoutGap="16px"
  fxLayoutGap.lt-sm="8px"
  [ngClass]="padding"
  [fxLayout]="direction"
  [fxLayoutAlign]="fxAlignment"
>
  <ng-content />
</div>
